import { useCallback } from "react";
import ConfigurationTargetBoxDetails from "./ConfigurationTargetBoxDetails";
import { MVisionAppClient } from '../../store/configurationTarget/mvision-client-list';
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../../store/store";
import { ModelType } from "../../store/global-types/customization-types";
import { allModelCustomizationsReset, modelCustomizationExported, modelCustomizationImported, modelCustomizationImportFailed, modelCustomizationPdfExportRequested, resetCustomizationImportExportError } from "../../store/adapt/adaptSlice";
import { readModelCustomizationJsonFile } from "../../store/adapt/adapt-helpers";


const ConfigurationTargetBoxDetailsAdapt = () => {

    const dispatch = useDispatch();

    const isResetInProgress = useSelector((state: StoreState) => state.adapt.isAllModelCustomizationsResetInProgress);
    const resetErrorMessage = useSelector((state: StoreState) => state.adapt.allModelCustomizationsResetError);
    const importExportErrorMessage = useSelector((state: StoreState) => state.adapt.customizationImportExportError);
    const pdfExportInProgress = useSelector((state: StoreState) => state.adapt.pdfExportInProgress);

    const handleResetAllModelCustomizations = useCallback((configurationTarget: MVisionAppClient) => {
        dispatch(allModelCustomizationsReset(configurationTarget));
    }, [dispatch]);

    const handleExportModelCustomization = useCallback((configurationTarget: MVisionAppClient) => {
        dispatch(modelCustomizationExported(configurationTarget));
    }, [dispatch]);

    const handleExportPdf = useCallback((configurationTarget: MVisionAppClient) => {
        dispatch(modelCustomizationPdfExportRequested(configurationTarget));
    }, [dispatch]);

    const handleImportUserData = useCallback(async (jsonFile: File) => {
        // Clear previous error
        dispatch(resetCustomizationImportExportError());

        try {
            const readFile = await readModelCustomizationJsonFile(jsonFile);
            dispatch(modelCustomizationImported(readFile));
            return true;
        } catch (error) {
            console.log(error);
            dispatch(modelCustomizationImportFailed('Error importing Adapt+ configuration. Please ensure the imported data is valid.'));
            return false;
        }
    }, [dispatch]);

    return (
        <ConfigurationTargetBoxDetails
            modelType={ModelType.Adapt}
            isResetInProgress={isResetInProgress}
            resetErrorMessage={resetErrorMessage}
            onResetAllModelCustomizations={handleResetAllModelCustomizations}
            onExportModelCustomization={handleExportModelCustomization}
            onExportPdf={handleExportPdf}
            pdfExportInProgress={pdfExportInProgress}
            onImportUserData={handleImportUserData}
            importExportErrorMessage={importExportErrorMessage}

        />
    );
}

export default ConfigurationTargetBoxDetailsAdapt;
